import React from 'react';

import { orderBy } from 'lodash';
import { useState } from 'react';

import Point from '@material-ui/icons/ArrowDropDown';
import tableStyle from './tablesStyle';

import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { baseURL } from '../../env';
import { statusTypes } from '../../utils/CFuncs';
import MyLink from './MyLink';

const getCellImage = (image) => {
  return <img alt="avatar" style={tableStyle.avatar} src={image.picture ? `${baseURL}/users/${image.id}/picture/100` : '/img/default-avatar.png'} />;
};

const getCellStatus = (status) => {
  return (
    <MyLink pathname={status.pathname} state={status.state} onClick={status.onClick}>
      {status.statusName}
    </MyLink>
  );
};

const getCellDetails = (details) => {
  return (
    <MyLink pathname={details.pathname} state={details.state}>
      <img src="/img/startTestBtn@2x.png" alt="E-mail Button" />
    </MyLink>
  );
};

const getCellGoal = (goal) => {
  return (
    <MyLink pathname={goal.pathname} state={goal.state} onClick={goal.onClick}>
      {goal.value}
    </MyLink>
  );
};
const getCellRemove = (remove,entity,location) => {
  return (
    <Link
      to={{
        pathname: location.pathname
      }}
      onClick={remove.onClick}
    >
      {remove.value}
    </Link>
  );
};
const getCellUsers = (users) => {
  return (
    <MyLink pathname={users.pathname} state={users.state} onClick={users.onClick}>
      {users.value}
    </MyLink>
  );
};
const getCellPatients = (patients) => {
  return (
    <MyLink pathname={patients.pathname} state={patients.state} onClick={patients.onClick}>
      {patients.value}
    </MyLink>
  );
};
const getCellClinics = (clinicNames) => {
  const countMore = clinicNames.length - 1;
  const countMoreStr = countMore > 0 ? ` +${countMore}` : '';
  return <div>{clinicNames.length > 0 ? clinicNames[0] + `${countMoreStr}` : '-'}</div>;
};
const tableCellObject = {
  image: (data) => getCellImage(data),
  status: (data, entity) => getCellStatus(data),
  details: (data) => getCellDetails(data),
  remove: (data,entity,location) => getCellRemove(data,entity,location),
  goal: (data) => getCellGoal(data),
  users: (data) => getCellUsers(data),
  patients: (data) => getCellPatients(data),
  clinics: (data) => getCellClinics(data),
};

const HeaderCell = ({ name, textName, sorting, updateSorting, tableFields }) => {
  const [isHovered, setIsHovered] = useState(false);
  const isDesc = sorting.column === name && sorting.direction === 'desc';
  const isAsc = sorting.column === name && sorting.direction === 'asc';
  const canBeSorted = tableFields.find((field) => field.name === name)?.canBeSorted;
  const handleClick = () => {
    if (sorting.direction === 'desc') {
      updateSorting({ column: name, direction: 'asc' });
    } else {
      updateSorting({ column: name, direction: 'desc' });
    }
  };

  return (
    <TableCell
      style={canBeSorted ? { ...tableStyle.th_sorted } : { ...tableStyle.th }}
      key={name}
      onClick={handleClick}
      onMouseEnter={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
    >
      <div style={isHovered && canBeSorted ? tableStyle.colNameHover : tableStyle.colName}>{textName}</div>

      {canBeSorted && (
        <div>
          {isDesc && (
            <div style={tableStyle.sortIcon}>
              <Point style={tableStyle.dropDownSortIconUp} />
            </div>
          )}
          {isAsc && (
            <div style={tableStyle.sortIcon}>
              <Point style={tableStyle.dropDownSortIconDown} />
            </div>
          )}
        </div>
      )}
    </TableCell>
  );
};
const Thead = ({ sorting, updateSorting, tableFields }) => {
  const textNames = tableFields.map((col) => col.textName);
  const names = tableFields.map((col) => col.name);
  return (
    <TableHead style={tableStyle.tHead}>
      <TableRow style={tableStyle.tr}>
        {names.map((name, ind) => {
          const textName = textNames[ind];
          return <HeaderCell tableFields={tableFields} key={name} name={name} textName={textName} sorting={sorting} updateSorting={updateSorting} />;
        })}
      </TableRow>
    </TableHead>
  );
};

const ContentCell = ({ data, column, entity, field }) => {
  const dispatch = useDispatch();
  const location = useLocation();


  const getData = (location) => {
    try {
      const getItemComp = tableCellObject[column];
      if (typeof getItemComp === 'function') return getItemComp(data, entity,location);
      return data;
    } catch (error) {
      console.log(error);
      console.log(' error ' + column);
    }
  };
  return (
    <TableCell style={tableStyle.td} key={column}>
      {getData(location)}
    </TableCell>
  );
};

const Content = ({ entities, tableFields }) => {
  const columns = tableFields.map((col) => col.name);

  const getField = (name, tableFields) => {
    const field = tableFields.find((feild) => feild.name === name);
    return field;
  };
  return (
    <TableBody style={tableStyle.tbody}>
      {entities.map((entity) => (
        <TableRow key={entity.id} style={tableStyle.tr}>
          {columns.map((column) => (
            <ContentCell key={column} field={getField(column, tableFields)} data={entity[column]} column={column} entity={entity} />
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
};

export default function EntityTable({ entities, tableFields }) {
  const [sorting, setSorting] = useState({ column: 'id', direction: 'asc' });
  const { searchTxt, status } = useSelector((state) => state.filter);

  const updateSorting = (newSorting) => {
    setSorting(newSorting);
  };

  const sortEntities = (list) => {
    console.log(sorting.direction + '1');

    return orderBy(list, [sorting.column], [sorting.direction]);
  };
  const filterEntities = (list = []) => {
    let newList = list || [];
    return newList.filter((entity) => {
      for (const value of Object.entries(entity)) {
        if (String(value).toLowerCase().includes(searchTxt.toLowerCase())) {
          return true;
        }
      }
      return false;
    });
  };

  const filterByStatus = (list) => {
    if (status == -1) return list;
    return list.filter((entity) => String(entity.status.statusName) === String(statusTypes[status]));
  };

  const getList = (list) => {
    const filteredList = filterEntities(list);
    const sortedList = sortEntities(filteredList);
    const filteredStatusList = filterByStatus(sortedList);
    return filteredStatusList;
  };

  console.log({ status, entities });
  return (
    <div>
      {/* <Select updateStatus={updateStatus} /> */}
      <Table style={tableStyle.table}>
        {/* <table style={tableStyle.table}> */}
        <Thead updateSorting={updateSorting} sorting={sorting} tableFields={tableFields} />
        <Content entities={getList(entities)} sorting={sorting} tableFields={tableFields} />
      </Table>
    </div>
  );
}
